import { Component } from '@angular/core';
import {AutoScraperBackendService} from "../auto-scraper-backend.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-top-navbar',
    templateUrl: './top-navbar.component.html',
    styleUrls: ['./top-navbar.component.css'],
    standalone: false
})
export class TopNavbarComponent {
  constructor(public data: AutoScraperBackendService, private router: Router) {}

  onLogout(): void {
    this.data.logout();
    this.router.navigate(['/login']);
  }
}
